import DefaultLayout from '@src/layout/default-page-layout.vue'

import { Route } from './ARoute'

export const constantRoutes = [
  Route.withPath('/', 'landingPage/landingPage').withName('landingPage'),
  Route.withPageLayout('').addChildren(
    Route.withPath('/redirect/:path*', 'redirect').withName('redirect'),
    Route.withPath('/403', '403')
      .withName('error.403')
      .withTitle('error.403'),
    Route.withPath('/404', '404')
      .withName('error.404')
      .withTitle('error.404')
  ),
  Route.withPath('/', DefaultLayout)
    .addChildren(
      [
        Route.withPath('/dang-nhap', 'login')
          .withName('login')
          .withNoAuth(),
        Route.withPath('chon-quyen', 'login-role-select')
          .withName('login.select_role')
          .withAuth(),
        Route.withPath('tu-lieu-ban-do', 'share/share-view')
          .withName('map-share-view')
          .withTitle('Tư liệu bản đồ')
      ]
    ),
]

export const Wildcard404 = Route.withPath('*', '404').withTitle('error.404')
